import { buildPayloadApiUrl, payloadFetch } from "./client";
import { mapRestaurantPromoDoc } from "src/utils/mapRestaurantPromo";

/**
 * @param {string} slug - localized URL segment
 * @param {string} locale - `en` | `fr`
 * @param {{ draft?: boolean, depth?: number }} [options]
 * @returns {Promise<ReturnType<typeof mapRestaurantPromoDoc> | null>}
 */
export async function fetchRestaurantPromoBySlug(slug, locale, options = {}) {
  const trimmed = typeof slug === "string" ? slug.trim() : "";
  if (!trimmed) return null;

  const lang = locale === "fr" ? "fr" : "en";
  const depth = options.depth ?? 2;

  const url = buildPayloadApiUrl("/api/restaurant-promotions", {
    locale: lang,
    limit: 1,
    depth,
    "where[slug][equals]": trimmed,
    ...(options.draft ? { draft: true } : {}),
  });

  const response = await payloadFetch(url);
  const doc = response?.docs?.[0];
  if (!doc) return null;
  return mapRestaurantPromoDoc(doc, lang);
}

/**
 * @param {string|number} id
 * @param {string} locale
 * @param {{ draft?: boolean, depth?: number }} [options]
 * @returns {Promise<ReturnType<typeof mapRestaurantPromoDoc> | null>}
 */
export async function fetchRestaurantPromoById(id, locale, options = {}) {
  if (id == null || id === "") return null;

  const lang = locale === "fr" ? "fr" : "en";
  const depth = options.depth ?? 2;

  const url = buildPayloadApiUrl(`/api/restaurant-promotions/${id}`, {
    locale: lang,
    depth,
    ...(options.draft ? { draft: true } : {}),
  });

  const doc = await payloadFetch(url);
  if (!doc?.id && !doc?.promotionKey) return null;
  return mapRestaurantPromoDoc(doc, lang);
}
